export default  {
  bindings: {
    property: '='
  },
  controller: 'propertyFormController',
  template: require('../views/property.form.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/components/property.form.component.js